/**
 * This regex should only be used on hostnames or domains and is not
 * robust enough to handle raw urls (eg. urls with ports or paths).
 */
export var TLD_REGEX = /(chegg[^\.]*)(.+)$/;
export var CheggTlds = {
  "default": '.com',
  MX: '.com.mx'
};
export var CheggHeaderKeys = {
  HOSTNAME: 'x-chegg-hostname',
  PASSPORT: 'chegg-passport'
};